import React, { Component } from "react";
import { reduxForm } from "redux-form";
import "./style.css";
import Api from "../../services/api";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as modalAction from "../../actions/modalAction";
import LocalTable from "../../components/CustomTable/LocalTable";
import DistrictTable from "../../components/CustomTable/DistrictTable";
import HorizontalSteps from "../../components/HorizontalSteps";
import { Link } from "react-router-dom";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this._getCategories = this._getCategories.bind(this);
    this.state = {
      activeTab: 1,
      activeTabIndex: 0,
      activeCategoryIndex: 0,
      categories: [],
      isLoading: true,
      answers: null,
      hasCompleted: {},
      isCompleted: {},
      answerDocs: {},
      print: false,
      remarksTicked: [],
      autoFocus: false,
      local: [],
      current_stage: [],
      status: 0,
      provinceId: 0,
      stepData: [
        {
          date: "2021/01/01",
          title: "मन्त्रालयबाट अनुशिक्षण सम्पन्न",
        },
        {
          date: "2021/01/01",
          title: "मन्त्रालयबाट प्रारम्भिक नतिजा तयार",
        },
        {
          date: "2021/01/01",
          title:
            "मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट मूल्याङ्कन गर्न तय मिति",
        },
        {
          date: "2021/01/01",
          title:
            "मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट प्रारम्भिक नतिजा तयार",
        },
        {
          date: "2021/01/01",
          title:
            "मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट तयार प्रारम्भिक नतिजामा मन्त्रालयको पृष्ठपोषण",
        },
        {
          date: "2021/01/01",
          title: "मन्त्रालयबाट पृष्ठपोषण हेरी अन्तिम नतिजा तयार",
        },
      ],
    };
  }

  componentDidMount() {
    this._getCategories();
  }

  async _getCategories() {
    const { user } = this.props;
    try {
      let response;
      if (user.role_level === "ministry") {
        response = await Api.getLocalDashboard(
          user.fiscal_year_id,
          user.ministry_id
        );
        let categories = response.response.stages;
        let status = response.response.current_stage;
        this.setState({
          local: categories,
          current_stage: response.response.current_stage,
          status: status,
          isLoading: false,
        });

        this.setState({
          local: response,
          categories,
          activeTab: categories[0].subCategories[0].id,
          firstTab: categories[0].subCategories[0].id,
          isLoading: false,
        });
      } else if (user.role_level === "ocmcm") {
        response = await Api.getDistrictDashboard(
          user.fiscal_year_id,
          user.province_id
        );
        let categories = response.response;
        this.setState({
          local: categories,
          current_stage: response.response.current_stage,
        });

        this.setState({
          local: response,
          categories,
          activeTab: categories[0].subCategories[0].id,
          firstTab: categories[0].subCategories[0].id,
          isLoading: false,
        });
      }
    } catch (e) {
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
      });
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { handleSubmit, user } = this.props;
    let { isLoading, stepData, status } = this.state;
    let newStatus = status;
    return (
      <>
        <section className="chart-section">
          {user.role_level === "ocmcm" ? (
            <DistrictTable
              comments={this.state.local}
              current_stage={this.state.current_stage}
              isLoading={isLoading}
            />
          ) : (
            <div>
              <HorizontalSteps activeStep={newStatus} stepData={stepData} />
              <div className="d-flex justify-content-end mb-4">
                <Link
                  to={`/financial_governance/${sessionStorage.getItem(
                    "provinceId"
                  )}`}
                >
                  {" "}
                  {/* <button className="btn btn-primary">वित्तीय सुशासन</button> */}
                </Link>
              </div>

              <LocalTable
                isLoading={isLoading}
                comments={this.state.local}
                current_stage={this.state.current_stage}
              />
            </div>
          )}
        </section>
      </>
    );
  }
}

Dashboard = reduxForm({
  // a unique name for the form
  form: "Dashboard",
})(Dashboard);

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  onDocumentsShow: (modalProps) => {
    dispatch(
      modalAction.processModal(
        modalAction.SHOW_MODAL,
        modalAction.ModalTypes.SHOW_DOCUMENT,
        modalProps
      )
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
